<template>
	<div v-if="menu.length > 0">
		<div class="mia-navbarCategories container">
			<div v-for="category in menu" :key="category.Title" class="mia-blogCategory">
				<a :href="category.Url" class="btn mia-navbarCategory">{{ category.Title }}</a>
				<div class="mia-blogMenuWrapperExpanded">
					<div class="mia-blogMenuWrapper">
						<div class="mia-blogNavbarBottom">
							<ul v-for="subcategory in category.Submenus" :key="subcategory.Title">
								<li class="mia-blogSubcategoryHeader">
									<a :href="subcategory.Url" class="mia-blogSubcategory">{{ subcategory.Title }}</a>
								</li>
								<li v-for="page in subcategory.Submenus" :key="page.Title" class="mia-blogSubcategoryLinks">
									<ul>
										<li>
											<a :href="page.Url" class="mia-blogPage">{{ page.Title }}</a>
										</li>
										<li v-for="subpage in page.Submenus" :key="subpage.Title" class="mia-blogSubpages">
											<a :href="subpage.Url">{{ subpage.Title }}</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "@/Reinforced.Typings";

@Component
export class NavbarBlog extends Vue {
	@Prop({ type: Array, required: true }) menu!: MiaPlaza.ConfigModel.LandingPage.IMenuOptions[];
}

export default toNative(NavbarBlog);
</script>
<style lang="scss">
.mia-NavbarBlog {
	display: flex;
	width: 100%;
	flex-flow: column;
	flex-wrap: nowrap;
	position: relative;
	background-color: theme.$mia-color-navbar-parent-fixed;
	color: theme.$mia-color-navbar-parent-fixed-font;

	.mia-blogMenuWrapper {
		width: 100%;
	}

	.mia-navbarCategories {
		display: flex;
		flex-wrap: wrap;
		flex-grow: 2;
		justify-content: left;
		padding: theme.$mia-grid-gutter-width 0;
		border-top: theme.$mia-border-width-panel-small solid theme.$mia-color-panel-separator;
		list-style: none;
	}

	.mia-blogCategory {
		margin-right: theme.$mia-navbar-blog-category-margin;
	}

	.mia-blogCategory:hover .mia-navbarCategory {
		border-bottom: theme.$mia-border-width-panel solid theme.$mia-color-themeMain;
	}

	.mia-navbarCategory {
		padding: theme.$mia-padding-panel-small theme.$mia-padding-panel;
		line-height: theme.$mia-navbar-blog-category-line-height;
		border: none;

		&:hover {
			text-decoration: none;
		}
	}

	.mia-blogCategory a {
		background-color: inherit;
		color: theme.$mia-color-navbar-parent-fixed-link-font;
		border-radius: unset;
	}

	.mia-blogSubcategory:hover {
		color: theme.$mia-color-themeContrast;
		text-decoration: none;
	}

	.mia-navbar-blog li {
		list-style: none;
	}

	.mia-blogMenuWrapperExpanded {
		display: none;
		position: absolute;
		left: 0;
		right: 0;
	}

	.mia-blogCategory:hover .mia-blogMenuWrapperExpanded {
		display: flex;
	}

	.mia-blogNavbarBottom:before {
		content: "";
		position: absolute;
		top: 0;
		// We force the container to span the width of the page regardless of screen size, to match the wordpress site.
		left: -100vw;
		right: -100vw;
		bottom: 0;
		background-color: theme.$mia-color-navbar-parent-subcategories-container;
		box-shadow: theme.$mia-list-shadow-box;
	}

	.mia-blogNavbarBottom {
		display: flex;
		padding: theme.$mia-padding-panel-large 0;
		background-color: inherit;
		color: theme.$mia-color-contrastPanel-font;
		justify-content: left;
	}

	.mia-blogNavbarBottom ul {
		z-index: theme.$mia-zIndex-1--foreground;
		display: flex;
		flex-flow: column;
	}

	.mia-blogNavbarBottom ul:not(:last-child) {
		margin-right: theme.$mia-navbar-blog-category-margin;
	}

	.mia-blogSubcategoryHeader, .mia-blogSubcategoryLinks {
		padding: theme.$mia-padding-panel;
	}

	.mia-blogSubcategory {
		color: theme.$mia-color-navbar-blog-link;
		// Ensure that the formatting matches the wordpress site
		text-transform: uppercase;
		font-size: theme.$list-group-item-font-size;
	}

	a.mia-blogPage {
		color: theme.$mia-color-navbar-parent-fixed-blog-page-link-font;
		font-size: theme.$list-group-item-font-size;

		&:hover {
			text-decoration: none;
		}
	}

	.mia-blogSubpages {
		font-size: theme.$font-size-h6;
		margin-top: theme.$mia-margin-size;
		cursor: pointer;

		&::before {
			// "\2022" is the code for a list disc; we define the lists like this because css does not support custom
			// styling for the default styles. Doing this allows us to apply custom colors and margins to match the blog.
			content: "\2022";
			color: theme.$mia-color-navbar-parent-fixed-blog-subpage-link-font;
			background-color: inherit;
			margin-left: theme.$mia-margin-size-large;
			margin-right: theme.$mia-margin-size;
		}

		a {
			color: theme.$mia-color-navbar-parent-fixed-blog-subpage-link-font;
			background-color: inherit;
		}
	}

	@media(max-width: theme.$screen-xs-max) {
		.mia-blogNavbarBottom {
			display: flex;
			flex-direction: column;
		}

		.mia-blogSubcategoryLinks {
			display: none;
		}
	}
}
</style>
